module.exports = __webpack_public_path__ + "static/img/369.92229ef.png";